import type { Folder } from '@/types/domain';

export interface FolderNode {
  folder: Folder;
  children: FolderNode[];
}

export function buildFolderTree(folders: Folder[]): FolderNode[] {
  const byId = new Map<string, FolderNode>();
  for (const f of folders) byId.set(f.id, { folder: f, children: [] });
  const roots: FolderNode[] = [];
  for (const node of byId.values()) {
    if (node.folder.parentId && byId.has(node.folder.parentId)) {
      byId.get(node.folder.parentId)!.children.push(node);
    } else {
      roots.push(node);
    }
  }
  const sortRec = (nodes: FolderNode[]): FolderNode[] => {
    nodes.sort((a, b) => a.folder.position - b.folder.position || a.folder.name.localeCompare(b.folder.name));
    for (const n of nodes) sortRec(n.children);
    return nodes;
  };
  return sortRec(roots);
}
